<template>
  <div class="d-flex flex-row">
    <div
      v-for="item in max"
      :key="item"
      @mouseover="handleMouseOver(item)"
      @mouseleave="handleMouseLeave"
      @click="handleClick(item)"
    >
      <mdb-icon
        :icon="icon"
        :fas="item <= rating"
        :far="item > rating"
        :color="color"
        :size="size"
        :style="{ color: hexColor ? `${hexColor} !important` : null }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 5,
    },
    items: {
      type: Array,
      default: null,
    },
    icon: {
      type: String,
      default: "star",
    },
    color: {
      type: String,
      default: null,
    },
    hexColor: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "1x",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveredValue: null,
    };
  },
  computed: {
    rating() {
      return this.hoveredValue ?? this.value;
    }
  },
  methods: {
    handleClick(index) {
      if (!this.readonly) {
        this.$emit("input", index);
      }
    },
    handleMouseOver(index) {
      if (!this.readonly) {
        this.hoveredValue = index;
      }
    },
    handleMouseLeave() {
      if (!this.readonly) {
        this.hoveredValue = null;
      }
    },
  },
};
</script>
<style lang="scss">
</style>